module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "normal4"
  }, [_c('span', {
    staticClass: "charoverride3"
  }, [_c('br', {
    staticClass: "calibre4"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal4"
  }, [_c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("In loving memory of Baffi, my feline muse"), _c('br', {
    staticClass: "calibre7"
  }), _vm._v("for this book and all the others.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aa8e678","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Dedication.vue
// module id = 72
// module chunks = 0